export default {
    km: require('./km.json'),
    en: require('./en.json'),
    fr: require('./fr.json'),
};
